"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaTypes = exports.DevicesTypes = exports.CtaTypeArray = void 0;
var CtaTypeArray = ['button', 'link'];
exports.CtaTypeArray = CtaTypeArray;
var DevicesTypes;
exports.DevicesTypes = DevicesTypes;

(function (DevicesTypes) {
  DevicesTypes["DESKTOP"] = "desktop";
  DevicesTypes["TABLET"] = "tablet";
  DevicesTypes["MOB"] = "mobile";
})(DevicesTypes || (exports.DevicesTypes = DevicesTypes = {}));

var DevicesVariantsArray = Object.values(DevicesTypes);
var MediaTypes;
exports.MediaTypes = MediaTypes;

(function (MediaTypes) {
  MediaTypes["VIDEO"] = "video";
  MediaTypes["IMAGE"] = "image";
})(MediaTypes || (exports.MediaTypes = MediaTypes = {}));